import Cookies from "js-cookie";
import queryString from "query-string";
import { defaultSearchParams } from "../constants";
import getNumberArrayFromSearchParam from "utils/getNumberArrayFromSearchParam";
import getStringFromSearchParam from "utils/getStringFromSearchParam";
import { setStatisticsLastSearchParams } from "reducers/LastSearchParams";
import { Dispatch, UnknownAction } from "redux";
import { useEffect, useState } from "react";

const useStatisticsSearchParams = ({
  searchProperties,
  dispatch
}: {
  searchProperties: string;
  dispatch: Dispatch<UnknownAction>;
}) => {
  const [searchParams, setSearchParams] = useState(defaultSearchParams);
  useEffect(() => {
    const cookiePageSize = Cookies.get("pageSizeInvoice");
    const newSearchParams = queryString.parse(searchProperties);
    const page = newSearchParams.page ? +newSearchParams.page - 1 : defaultSearchParams.page;
    const search = newSearchParams.search
      ? (newSearchParams.search as string)
      : defaultSearchParams.search;
    const ordering = newSearchParams.ordering
      ? (newSearchParams.ordering as string)
      : defaultSearchParams.ordering;
    const page_size = newSearchParams.page_size
      ? +newSearchParams.page_size
      : cookiePageSize
        ? +cookiePageSize
        : defaultSearchParams.page_size;
    const ord_account = newSearchParams.ord_account
      ? getNumberArrayFromSearchParam(newSearchParams.ord_account)
      : defaultSearchParams.filter?.ord_account;
    const combined_status = newSearchParams.combined_status
      ? getNumberArrayFromSearchParam(newSearchParams.combined_status)
      : defaultSearchParams.filter?.combined_status;
    const start_date = newSearchParams.start_date
      ? getStringFromSearchParam(newSearchParams.start_date)
      : defaultSearchParams.filter?.start_date;
    const end_date = newSearchParams.end_date
      ? getStringFromSearchParam(newSearchParams.end_date)
      : defaultSearchParams.filter?.end_date;
    const contract = newSearchParams.contract
      ? getNumberArrayFromSearchParam(newSearchParams.contract)
      : defaultSearchParams.filter?.contract;
    setSearchParams({
      page,
      search,
      ordering,
      page_size,
      filter: {
        ord_account,
        combined_status,
        start_date,
        end_date,
        contract,
      }
    });
    dispatch(setStatisticsLastSearchParams(searchProperties));
  }, [searchProperties]);

  return searchParams
}
export default useStatisticsSearchParams;
